export default __webpack_public_path__ + "static/media/resposta_certa_02.ac5c4bdf.mp3";